function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 4C12.3923 4 11.5 4.89228 11.5 6V16.5C11.5 16.7777 11.7223 17 12 17C12.2777 17 12.5 16.7777 12.5 16.5V7H14.5V16.5C14.5 17.8823 13.3823 19 12 19C10.6177 19 9.5 17.8823 9.5 16.5V6C9.5 3.78772 11.2877 2 13.5 2C15.7123 2 17.5 3.78772 17.5 6V16.5C17.5 19.5423 15.0423 22 12 22C8.95772 22 6.5 19.5423 6.5 16.5V7H8.5V16.5C8.5 18.4377 10.0623 20 12 20C13.9377 20 15.5 18.4377 15.5 16.5V6C15.5 4.89228 14.6077 4 13.5 4Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Attachment.js.map